import { get_token } from '@/router';
import { append_active_organization_id } from '@/utils/organization_profile';

export default {
initDataTable(id) {
      const table = $(id);

      if (!table.length) return;

      if ($.fn.DataTable.isDataTable(id)) {
        table.DataTable().destroy();
      }

      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        language: {
          paginate: {
            previous: "Previous",
            next: "Next"
          },
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "No entries available"
        }
      });
    },
refresh_discussion_table() {
      this.$nextTick(() => {
        this.initDataTable('#discussion-table');
      });
    },
destroy_discussion_table() {
      if ($.fn.DataTable.isDataTable('#discussion-table')) {
        $('#discussion-table').DataTable().destroy();
      }
    },
toggleSidebar() {
      if (!this.$refs.sidebar) return;
      this.$refs.sidebar.$el.classList.toggle("close");
    },
get_discussion_dashboard_value(key,
fallback = 0) {
      const value = Reflect.get(this.discussion_dashboard || {}, key);
      return [undefined, null, ''].includes(value) ? fallback : value;
    },
get_topic_comment_count(topic = {}) {
      const commentList = [
        Reflect.get(topic, 'comments'),
        Reflect.get(topic, 'discussion_comments')
      ].find(Array.isArray);

      return commentList
        ? commentList.length
        : this.get_topic_comment_total(topic);
    },
get_topic_comment_total(topic = {}) {
      return Number(
        Reflect.get(topic, 'comments_count')
        || Reflect.get(topic, 'comment_count')
        || 0
      );
    },
refresh_discussion_dashboard_from_list() {
      this.discussion_dashboard = {
        ...this.discussion_dashboard,
        total_count: (this.disscussion_topics || []).length,
        total_comments: this.local_comment_count,
      };
    },
get_discussion_response_topics(response = {}) {
      if (Array.isArray(response.data)) {
        return response.data;
      }

      return response.data?.topics
        || response.data?.discussion_topics
        || [];
    },
get_discussion_response_dashboard(response = {}) {
      return response.dashboard || {};
    },
open_discussion_form() {
      this.showDiscussionForm = true;
    },
cancel_edit_topic() {
      this.showEditTopicForm = false;
      this.editTopicData = { title: "", description: "", topic_id: null };
    },
close_discussion_form() {
      this.showDiscussionForm = false;
      this.topic_name = "";
      this.description = "";
      this.errors = {};
    },
getToken() {
      return get_token();
    },
create_discussion_topic_context() {
      const group_id = this.$route?.params?.group_id;
      if (group_id) {
        return this.create_group_discussion_topic();
      }
      return this.create_discussion_topic();
    },
validate_discussion_topic() {
      this.errors = {};
      let isValid = true;
      if (!this.topic_name.trim()) {
        this.errors.topic_name = "Please select a topic.";
      }
      if (!this.description.trim()) {
        this.errors.description = "Description is required.";
        isValid = false;
      }
      return isValid;
    },
prepare_discussion_description() {
      this.description = this.$refs.quillDiscussionsEditorRef.getHTML();
      this.description = this.description.replace(/<\/?p>/g, '').trim();

      if (!this.description || this.description === '<br>' || this.description === '<br/>') {
        this.description = '';
      }
    },
reset_created_discussion_form() {
      this.topic_name = '';
      this.description = '';
      this.$refs.quillDiscussionsEditorRef?.setHTML('');
    },
handle_created_discussion(response, close_form = false) {
      if (response?.status !== "success" || !response?.data?.id) return;

      this.destroy_discussion_table();
      this.disscussion_topics.unshift(response.data);
      this.refresh_discussion_dashboard_from_list();
      this.reset_created_discussion_form();

      this.$nextTick(() => {
        this.reset_created_discussion_form();
        if (close_form) {
          this.close_discussion_form();
        } else {
          $('#create_discussion').modal('hide');
        }
        this.refresh_discussion_table();
      });
    },
create_discussion_topic() {
      this.prepare_discussion_description();

      if (!this.validate_discussion_topic()) {
        return;
      }
      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_topic/`,
        data: JSON.stringify({
          ...append_active_organization_id({}),
          title: this.topic_name,
          description: this.description,
          portal_id: this.$route.params.portal_id,
          category_id: this.selected_category
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        contentType: 'application/json',
        success: (response) => {
          this.handle_created_discussion(response);
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    }
};

